
import { Link } from 'react-router-dom';

const BlogGrid = () => {
  const blogs = [
    {
      id: 1,
      slug: 'sosyal-medyada-sigorta-acentesi-nasil-buyur',
      title: 'Sosyal Medyada Sigorta Acentesi Nasıl Büyür?',
      excerpt: 'Sosyal medya platformlarını etkili kullanarak sigorta acentenizi nasıl büyütebileceğinizi, doğru içerik stratejileri ve hedef kitle analizi ile keşfedin.',
      image: 'https://public.readdy.ai/ai/img_res/f0b4be3f696cc791d220bd0809c74ed4.jpg',
      category: 'Sosyal Medya',
      date: '15 Ocak 2025',
      readTime: '8 dk',
      author: 'Sigorota360 Ekibi',
    },
    {
      id: 2,
      slug: 'dijital-reklamcilikta-basari-icin-5-altin-kural',
      title: 'Dijital Reklamcılıkta Başarı İçin 5 Altın Kural',
      excerpt: 'Meta ve Google reklamlarında bütçenizi en verimli şekilde kullanarak maksimum dönüşüm elde etmenin yollarını öğrenin.',
      image: 'https://readdy.ai/api/search-image?query=digital%20advertising%20dashboard%20showing%20successful%20campaign%20metrics%20with%20colorful%20charts%20graphs%20and%20ROI%20statistics%20on%20modern%20computer%20screen%20in%20professional%20workspace%20with%20clean%20simple%20background&width=800&height=500&seq=blog2&orientation=landscape',
      category: 'Dijital Reklamcılık',
      date: '10 Ocak 2025',
      readTime: '6 dk',
      author: 'Sigorota360 Ekibi',
    },
    {
      id: 3,
      slug: 'crm-sistemi-neden-her-acentenin-olmali',
      title: 'CRM Sistemi Neden Her Acentenin Olmalı?',
      excerpt: 'Müşteri ilişkileri yönetimi sistemlerinin sigorta acenteleri için neden vazgeçilmez olduğunu ve nasıl verimlilik artırdığını keşfedin.',
      image: 'https://readdy.ai/api/search-image?query=modern%20CRM%20system%20interface%20showing%20customer%20relationship%20management%20dashboard%20with%20organized%20data%20contacts%20and%20automation%20workflows%20on%20sleek%20computer%20display%20in%20professional%20office%20with%20minimalist%20background&width=800&height=500&seq=blog3&orientation=landscape',
      category: 'CRM & Otomasyon',
      date: '5 Ocak 2025',
      readTime: '7 dk',
      author: 'Sigorota360 Ekibi',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog) => (
            <Link
              key={blog.id}
              to={`/akademi/${blog.slug}`}
              className="group bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#007dff]/30 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1.5 bg-white/95 backdrop-blur-sm rounded-lg font-poppins text-xs font-semibold text-[#007dff]">
                    {blog.category}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-4 mb-4 text-sm text-gray-500 font-inter">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-[#007dff]"></i>
                    {blog.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-[#007dff]"></i>
                    {blog.readTime}
                  </span>
                </div>

                <h3 className="font-poppins font-bold text-xl text-gray-900 mb-3 group-hover:text-[#007dff] transition-colors leading-tight">
                  {blog.title}
                </h3>

                <p className="font-inter text-sm text-gray-600 leading-relaxed mb-4">
                  {blog.excerpt}
                </p>

                <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                  <span className="font-inter text-sm text-gray-500">{blog.author}</span>
                  <span className="flex items-center gap-2 font-poppins text-sm font-semibold text-[#007dff] group-hover:gap-3 transition-all">
                    Devamını Oku
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogGrid;
